import { Typography as MuiTypography } from "@mui/material";
import * as React from "react";

import type { TypographyProps } from "./types";

export const Typography = React.forwardRef<HTMLSpanElement, TypographyProps>(({ children, ...props }, ref) => (
  <MuiTypography
    ref={ref}
    {...props}
  >
    {children}
  </MuiTypography>
));
